import { ServiceConfig } from 'interfaces';
import { AppServices } from 'interfaces/AppServices';
import { GoPersonalService } from './GoPersonal/GoPersonalService';
import { PacksService } from './Packs/PacksService';
import { ReportService } from './Reports/ReportService';

export class ServiceFactory {
    public appServices: AppServices;

    constructor(config: ServiceConfig) {
        this.validateConfig(config);
        this.appServices = {
            reportService: new ReportService(
                import.meta.env.VITE_REPORTS_BASE_URL as string,
                config.apiToken,
                config.tenant,
            ),
            goPersonalService: new GoPersonalService(
                import.meta.env.VITE_EMPLOYEE_BASE_URL as string,
                config.userToken,
                config.packId,
            ),
            packsService: new PacksService(
                import.meta.env.VITE_PACKS_BASE_URL as string,
                config.userToken,
                config.packId,
            ),
        };
    }

    public getServices(): AppServices {
        return this.appServices;
    }

    private validateConfig(config: ServiceConfig) {
        if (!import.meta.env.VITE_REPORTS_BASE_URL || !import.meta.env.VITE_EMPLOYEE_BASE_URL) {
            throw new Error('Missing VITE_REPORTS_BASE_URL or VITE_EMPLOYEE_BASE_URL environment variable');
        }
        if (!import.meta.env.VITE_PACKS_BASE_URL) {
            throw new Error('Missing VITE_PACKS_BASE_URL environment variable');
        }
        if (!config.tenant || !config.packId || !config.userToken || !config.apiToken) {
            throw new Error('Invalid service configuration');
        }
    }
}
